<template>
  <div v-if="settings">
    <b-card>
      <b-card-header>Inställningar iLog</b-card-header>
      <b-card-body>
          <b-row>
              <b-col>
                  <label>Transportörsnamn:</label><br>             
                  <input type="text" v-model="settings.TransporterName">
              </b-col>
          </b-row><b-row>
              <b-col>
                  <label>Transportörsnummer:</label>
                  <br>
                  <input type="text" v-model="settings.TransporterNumber">
              </b-col>
          </b-row>
        <b-row>
          <b-col>
            <label>Synka från iLog->Transplanet</label><br />
            <b-row>
              <b-col cols="1">
                <b-checkbox v-model="settings.CreateNewBookingsInTp"></b-checkbox>
              </b-col>
              <b-col>Skapa nya bokningar från iLog </b-col>              
            </b-row>
            <!-- <b-row>
              <b-col cols="1">
                <b-checkbox v-model="settings.GetResourceToTop"></b-checkbox>
              </b-col>
              <b-col>Hämta resurs från iLog </b-col>              
            </b-row> -->
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col>
            <label>Synka Transplanet -> iLog</label><br />
            <b-row>
              <b-col cols="1">
                <b-checkbox v-model="settings.SendResourceToiLog"></b-checkbox>
              </b-col>
              <b-col>Skicka resurs till iLog </b-col>              
            </b-row>            
          </b-col>
        </b-row> -->
        <b-row>            
            <hr>
            <b-col>
                <b-button @click="SaveChanges()">Spara ändringar</b-button>
            </b-col>
        </b-row>        
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "ilogsettings",
  props: { connector: Object },
  data() {
      return {
          settings: {}
      }
  },
  created() {
      this.settings = JSON.parse(this.connector.settings);
      if(!this.settings)
        this.settings = {};
  },
  methods: {
      SaveChanges() {
          if(confirm("Vill du spara ändringarna?")) {
            var o = Object.assign({}, this.connector);
            o.settings = JSON.stringify(this.settings);
            api.post('/api/apitenant/SaveConnectorSettings', o).then((res) => {
                alert('Ändringa sparade.');
            })      
          }
      }
  }
};
</script>

<style>
</style>